let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5DFaA")).then(() => parcelRequire('3PNvw'));